module.exports = new __parcel__URL__("pvp_button_bg.4698c358.png").toString();